if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 300));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

					// Update free delivery progress bar
					updateFreeDeliveryProgress();

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

			// Update free delivery progress bar
			updateFreeDeliveryProgress();

		})

	}

}

// Free Delivery Progress Bar Update Function
function updateFreeDeliveryProgress() {

	// Get current cart total from multiple possible sources
	let cartTotal = 0;
	
	// Try to get from cart total element first
	const cartTotalElement = document.querySelector('[data-cart-total]');
	if (cartTotalElement) {
		const cartTotalText = cartTotalElement.textContent.trim();
		cartTotal = parseFloat(cartTotalText.replace(/[^0-9.]/g, '')) || 0;
	}
	
	// If that fails, try to get from header cart total
	if (cartTotal === 0) {
		const headerCartTotal = document.querySelector('[data-header-cart-total]');
		if (headerCartTotal) {
			const headerTotalText = headerCartTotal.textContent.trim();
			cartTotal = parseFloat(headerTotalText.replace(/[^0-9.]/g, '')) || 0;
		}
	}
	
	// If still no total, try to fetch from cart API
	if (cartTotal === 0) {
		fetch('/cart.js')
			.then(response => response.json())
			.then(cart => {
				const apiCartTotal = cart.total_price / 100; // Shopify returns in cents
				updateProgressBarDisplay(apiCartTotal);
			})
			.catch(() => {
				// If all else fails, assume 0
				updateProgressBarDisplay(0);
			});
		return;
	}
	
	updateProgressBarDisplay(cartTotal);
}

function updateProgressBarDisplay(cartTotal) {
	const progressContainer = document.getElementById('free-delivery-progress');
	const progressFill = document.getElementById('progress-fill');
	const progressMessage = document.getElementById('progress-message');
	
	if (!progressContainer || !progressFill || !progressMessage) {
		return;
	}
	
	const freeDeliveryThreshold = 70.00;
	const remaining = Math.max(0, freeDeliveryThreshold - cartTotal);
	const progressPercentage = Math.min(100, (cartTotal / freeDeliveryThreshold) * 100);

	// Update progress bar width
	progressFill.style.width = progressPercentage + '%';

	// Update message and remaining amount
	if (remaining > 0) {
		progressMessage.innerHTML = `Add <span class="remaining-amount">$${remaining.toFixed(2)}</span> more for FREE delivery!`;
		progressContainer.classList.remove('achieved');
	} else {
		progressMessage.innerHTML = `<span class="congratulations-message">🎉 Congratulations! You've qualified for <strong>FREE delivery</strong>! 🚚</span>`;
		progressContainer.classList.add('achieved');
	}
}

// Initialize progress bar on page load
document.addEventListener('DOMContentLoaded', function() {
	// Initial update
	updateFreeDeliveryProgress();
	
	// Also update after a short delay to ensure all elements are loaded
	setTimeout(updateFreeDeliveryProgress, 500);
	
	// Listen for cart-updated events
	document.addEventListener('cart-updated', function() {
		updateFreeDeliveryProgress();
	});
	
	// Listen for add-to-cart events
	document.addEventListener('add-to-cart', function() {
		setTimeout(updateFreeDeliveryProgress, 100);
	});
	
	// Also update when cart drawer is opened
	const cartDrawer = document.getElementById('site-cart-sidebar');
	if (cartDrawer) {
		const observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
					const isVisible = cartDrawer.style.display !== 'none';
					if (isVisible) {
						setTimeout(updateFreeDeliveryProgress, 100);
					}
				}
			});
		});
		observer.observe(cartDrawer, { attributes: true });
	}
});